<section class="main-section  w-100 h-100">
  <div class="total_section w-100 h-100" *ngIf="!pageLoader; else totalPageLoading" style="overflow: hidden;">
    <div class="pages_top_sec gap-2 d-flex justify-content-between mb-3">
      <div class="left-side w-65">
        <div class="tab_sec">
          <div class="active-toggle d-flex">
            <ng-container *ngFor="let item of templateTab; let i = index">
              <button [ngClass]="item.status ? 'activeTab' : 'options'" (click)="setActiveTab(i)"
                matTooltip="{{item.name}}">
                {{item.name}} ({{item.count}})
              </button>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="search_section d-flex align-items-center">
        <input [(ngModel)]="searchTemplateName" (ngModelChange)="searchTemplate()" class="w-100"
          placeholder="Search Template">
      </div>
      <div class="right-side">
        <div class="add-business-section" (click)="addTemplate()">
          + Create Template
        </div>
      </div>
    </div>
    <div class="pages_body_sec">
      <div class="total_body_section gap-3 d-flex w-100 h-100">
        <div class="body_left_sec h-100 p-2">
          <div class="left_top_section">
            <div class="search-bar w-100">
              <mat-form-field class="w-100 sfull-width input_card h-100" appearance="outline">
                <input matInput placeholder="Search by sub industry" [(ngModel)]="searchIndustryText"
                  style="height: 36px !important;font-size: 13px;font-family: lexandReg;" (keyup)="searchIndustry()" />
                <mat-icon matPrefix style="font-size: 20px;padding: 6px;"
                  class="d-flex justify-content-center align-items-center">search</mat-icon>
              </mat-form-field>
            </div>
          </div>
          <div class="result_section mt-2">
            <div class="list_comp_categories h-100 w-100">
              <ng-container *ngFor="let item of duplicateInstriesList">
                <div class="single_categoy cursor-pointer d-flex justify-content-between align-items-center"
                  [ngClass]="item.status ? 'single_categoy_active' : ''" (click)="selectIndustry(item)">
                  {{item?.name}}
                  <div class="item_count">{{item.count}}</div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="body_right_sec h-100 p-2">
          <div class="right_result_sec w-100">
            <div class="result_total_sec d-grid" *ngIf="filteredPagesList.length > 0; else noTemplates"
              style="grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 2rem;">
              <ng-container *ngFor="let item of filteredPagesList">
                <div class="single_template">
                  <div class="image-container">
                    <img
                      [src]="(item.screenShot != null && item.screenShot != 'string' && item.screenShot != '') ? item.screenShot : 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png?20210521171500'"
                      alt="Sample Image">
                    <div class="overlay">
                      <button class="edit_btn" (click)="editComponent(item)" matTooltip="Edit">
                        <img src="assets/images/master/edit-icon.svg" alt="edit" style="width:15px;height:15px">
                      </button>
                      <button class="edit_btn" (click)="deleteComponent(item)" matTooltip="Delete">
                        <img src="assets/images/master/delete-icon.svg" alt="delete" style="width:15px;height:15px">
                      </button>
                      <button class="edit_btn" (click)="viewComponent(item)" matTooltip="View">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button class="edit_btn" (click)="showPreviewPage(item)" matTooltip="Info">
                        <mat-icon>info</mat-icon>
                      </button>
                      <button class="edit_btn" (click)="duplicateComponent(item, duplicateDialog)"
                        matTooltip="Duplicate">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div class="simpo_name">{{ item.name ? item?.name : 'Untitled Template' }}</div>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-template #noTemplates>
            <div class="no-templates-message">
              <mat-icon class="empty-icon">folder_open</mat-icon>
              <h3>{{getNoTemplatesMessage()}}</h3>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #totalPageLoading>
  <div class="img_sec h-100 w-100">
    <app-global-lottie-loader></app-global-lottie-loader>
  </div>
</ng-template>

<!-- ✅ Duplicate Dialog -->
<ng-template #duplicateDialog>
  <!-- Top accent bar -->
  <div style="height:4px; background:#5f0065; border-radius:4px 4px 0 0;"></div>

  <!-- Header -->
  <div style="padding:20px 24px 16px; display:flex; justify-content:space-between; align-items:flex-start;">
    <div>
      <p
        style="font-size:11px; font-weight:500; color:#5f0065; text-transform:uppercase; letter-spacing:0.08em; margin:0 0 4px;">
        Template Action</p>
      <h2 style="font-size:17px; font-weight:600; color:#101828; margin:0;">Duplicate Template</h2>
    </div>
    <button (click)="closeDuplicateDialog()"
      style="background:#f4f4f5; border:none; border-radius:50%; width:32px; height:32px; display:flex; align-items:center; justify-content:center; cursor:pointer;">
      <mat-icon style="font-size:18px; width:18px; height:18px; color:#667085;">close</mat-icon>
    </button>
  </div>

  <!-- Template info card -->
  <div
    style="margin:0 24px 20px; background:#f9fafb; border-radius:8px; padding:14px 16px; display:flex; align-items:center; gap:14px; border-left:3px solid #5f0065;">
    <div
      style="width:40px; height:40px; border-radius:8px; background:rgba(95,0,101,0.08); display:flex; align-items:center; justify-content:center; flex-shrink:0;">
      <mat-icon style="font-size:20px; width:20px; height:20px; color:#5f0065;">content_copy</mat-icon>
    </div>
    <div>
      <p style="font-size:14px; font-weight:600; color:#101828; margin:0 0 2px;">{{ dupItem?.name || 'Untitled Template'
        }}</p>
      <p style="font-size:12px; color:#667085; margin:0;">Will be duplicated to a new sub-industry</p>
    </div>
  </div>

  <div style="padding:0 24px 20px; display:flex; flex-direction:column; gap:16px;">

    <!-- Sub-industry -->
    <div>
      <label
        style="font-size:11px; font-weight:500; color:#667085; display:block; margin-bottom:6px; text-transform:uppercase; letter-spacing:0.06em;">
        Sub-Industry <span style="color:#f04438;">*</span>
      </label>
      <mat-form-field appearance="outline" style="width:100%;">
        <input matInput placeholder="Search sub-industry..." [(ngModel)]="dupSearchText"
          (ngModelChange)="dupFilterIndustries()" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>

      <!-- Industry list -->
      <div *ngIf="dupFilteredIndustries.length > 0"
        style="max-height:160px; overflow-y:auto; border:1px solid #e4e7ec; border-radius:0 0 8px 8px; margin-top:0px;">
        <div *ngFor="let ind of dupFilteredIndustries; let last = last" (click)="dupSelectIndustry(ind)"
          [style.background]="dupSelectedIndustry?.id === ind.id ? 'rgba(95,0,101,0.08)' : '#fff'"
          [style.borderBottom]="last ? 'none' : '1px solid #f2f4f7'"
          style="display:flex; justify-content:space-between; align-items:center; padding:10px 14px; font-size:13px; cursor:pointer;">
          <span [style.color]="dupSelectedIndustry?.id === ind.id ? '#5f0065' : '#344054'"
            [style.fontWeight]="dupSelectedIndustry?.id === ind.id ? '600' : '400'">
            {{ ind.name }}
          </span>
          <mat-icon *ngIf="dupSelectedIndustry?.id === ind.id"
            style="font-size:18px; width:18px; height:18px; color:#5f0065;">check_circle</mat-icon>
        </div>
      </div>
      <div *ngIf="dupFilteredIndustries.length === 0"
        style="text-align:center; font-size:13px; color:#667085; padding:14px; border:1px solid #e4e7ec; border-radius:0 0 8px 8px; margin-top:0px;">
        No sub-industry found
      </div>
    </div>

    <!-- Template name -->
    <div>
      <label
        style="font-size:11px; font-weight:500; color:#667085; display:block; margin-bottom:6px; text-transform:uppercase; letter-spacing:0.06em;">
        Template Name <span style="color:#f04438;">*</span>
      </label>
      <mat-form-field appearance="outline" style="width:100%;">
        <input matInput placeholder="Enter template name" [(ngModel)]="dupTemplateName" />
      </mat-form-field>
    </div>

  </div>

  <!-- Footer -->
  <div
    style="padding:14px 24px 20px; border-top:1px solid #f0f0f0; display:flex; justify-content:flex-end; gap:10px; background:#f9fafb; border-radius:0 0 4px 4px;">
    <button (click)="closeDuplicateDialog()" class="d-flex align-items-center justify-content-center"
      style="padding:9px 20px; font-size:13px; font-weight:500; border:1px solid #d0d5dd; border-radius:6px; background:#fff; color:#344054; cursor:pointer;">
      Cancel
    </button>
    <button (click)="confirmDuplicate()" [disabled]="!dupSelectedIndustry || !dupTemplateName || dupLoading"
      [style.opacity]="(!dupSelectedIndustry || !dupTemplateName || dupLoading) ? '0.5' : '1'"
      class="d-flex align-items-center justify-content-center"
      style="padding:9px 20px; font-size:13px; font-weight:500; border:none; border-radius:6px; background:#5f0065; color:#fff; cursor:pointer; display:flex; align-items:center; gap:8px;">
      <mat-icon *ngIf="!dupLoading" style="font-size:16px; width:16px; height:16px;">content_copy</mat-icon>
      <mat-spinner *ngIf="dupLoading" diameter="18"></mat-spinner>
      {{ dupLoading ? 'Duplicating...' : 'Duplicate' }}
    </button>
  </div>

</ng-template>